<template>
  <!-- 导航栏-->
  <div class="main">
    <div class="nav-wrap">
      <div class="nav-box">
        <div class="nav-div">
          <div class="nav-left">
            <div class="logo">
              <img src="../assets/img/logo.png" alt="logo" @click="toHome">
            </div>
          </div>
          <div class="nav-right" v-if="$store.getters.userToken">
            <div class="auth-btn" @click="toAuthorization">添加公众号</div>
            <div class="official-account">
              <div class="official-div">
                <div v-if="platformName">
                  <img class="avatar" v-if="headImg" :src="headImg" alt="">
                  <img class="avatar" v-else src="~@/assets/img/official/weishouquan.png" alt="">
                </div>
                <div class="account-name">{{platformName}}</div>
                <span @click="changeAccount()" class="show-change" v-if="publicList.length > 1">切换公众号</span>
              </div>
              <div class="official-dialog-box" v-if="isShowAccount">
                <span class="bot"></span>
                <span class="top"></span>
                <div class="official-item">
                  <div class="official-item-div" v-for="(item,index) of publicList" :key="index">
                    <img v-if="item.headImg" :src="item.headImg" alt="">
                    <img v-else src="~@/assets/img/official/weishouquan.png" alt="">
                    <div class="color-666">{{item.platformName}}</div>
                    <div class="item-change" @click="changePubilc(item)">切换</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="user">
              <div class="user-div">
                <img class="avatar" v-if="userInfo.avatar" :src="userInfo.avatar" alt="">
                <img class="avatar" v-else src="~@/assets/img/official/head.png" alt="">
                <div class="nickname">{{userInfo ? userInfo.nickname : ''}}</div>
                <div class="arrow-img">
                  <img @click="changeArrow()" :src="this.arrowIcon" alt="">
                  <div class="nav-dialog-box" v-if="isShow">
                    <span class="bot"></span>
                    <span class="top"></span>
                    <div class="nav-item">
                      <div @click="toPromotion" :class="(activeItem == 0) ? 'active':''">我的推广位</div>
                      <div @click="toMyWechat" :class="(activeItem == 1) ? 'active':''">影票公众号</div>
<!--                      <div @click="toMyKfcWechat" :class="(activeItem == 3) ? 'active':''">肯德基公众号</div>-->
                      <div @click="toLogout" :class="(activeItem == 2) ? 'active':''">退出</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 导航栏-->
</template>

<script>
  import { Modal } from 'view-design'
  import { isLogin, getToken, getUserInfo, getPlatformName, getIsBasic, getUserUUID, getHasPackage, setPlatformUuid, setPlatformName, setSnapshotId, setIsOver, setIsBasic, setHasPackage, setIsAuthOfficial, getHeadImg, setHeadImg } from '@/utils/auth'
  import navArrowDowm from '@/assets/img/official/nav_btn_arrow_down.png'
  import navArrowUp from '@/assets/img/official/nav_btn_arrow_upward.png'
  import noHeadImg from '@/assets/img/official/weishouquan.png'
  import official from '@/javaApi/official'
  const officialModel = new official()
  export default {
    name: "OfficialNav",
    components: {
      navArrowDowm,
      navArrowUp,
      noHeadImg
    },
    data: function () {
      return {
        userInfo:{},
        isShowAccount: false,
        isShow: false,
        arrowIcon: navArrowDowm,
        listLoading: false,
        publicList: [],
        hasPackage: getHasPackage() === 'true' ? true : false,
        platformName: getPlatformName(),
        headImg: getHeadImg()
      }
    },
    created() {
      this.$store.dispatch('nav/changePersonalActiveIndex',1)
      this.userInfo = getUserInfo()
      this.getHasAuthPubilc();
    },
    computed: {
      activeItem: function () {
        return this.$store.getters.personalActiveIndex
      },
    },
    methods: {
      changeAccount () {
        if(this.isShowAccount === false){
          this.getHasAuthPubilc();
          this.isShowAccount = true
        }else{
          this.isShowAccount = false
        }
      },
      //获取公众号信息
      getHasAuthPubilc(){
        this.listLoading = true
        officialModel.getAuthPublicList({openUserUuid:getUserUUID()}).then((response) => {
          var res = response.data
          if(res.code != 200){
            this.$Message.error(res.message)
            return
          }
          this.publicList = res.data.binds
          this.listLoading = false
        }).catch(error=>{
            console.log(error)
            if(error != 'token invalid'){
              this.$Message.error('系统异常请稍后再试！')
            }
        })
      },
      //切换公众号
      changePubilc(row){
        var that  = this;
        that.$Message.success('公众号切换中...');
        setPlatformUuid(row.platformUuid);
        setPlatformName(row.platformName)
        if(row.snapshotId !== null){
          setSnapshotId(row.snapshotId)
        }else{
          setSnapshotId(0)
        }
        setIsOver(row.isOver)
        if(row.isProfit === 1){
          setIsBasic(false)
        }else{
          setIsBasic(true)
        }
        if(row.packageName !== null){
          setHasPackage(true)
        }else{
          setHasPackage(false)
        }
        if(row.platformUuid !== '' && row.platformName !== ''){
          setIsAuthOfficial(true)
        }else{
          setIsAuthOfficial(false)
        }
        setHeadImg(row.headImg)
        setTimeout(function(){
          that.$router.go(0)
        },300)
      },
      changeArrow () {
        if(this.isShow === false){
          this.isShow = true
          this.arrowIcon = navArrowUp
        }else{
          this.isShow = false
          this.arrowIcon = navArrowDowm
        }
      },
      //跳转到我的邀请
      toInvite(){
        var that = this
        this.hasPackage = getHasPackage() === 'true' ? true : false
        if(that.hasPackage === false){
          //未开通套餐时，点击任何菜单都是跳转到激活续费页面
          // 弹窗提示
          // Modal.warning({
          //   title: '提示',
          //   content: '您还未购买套餐类型！请先购买',
          //   onOk: function() {
          //     if(getIsBasic() === 'true'){
          //       that.$store.dispatch('nav/changeOfficialAccountActiveIndex',5)
          //     }else{
          //       that.$store.dispatch('nav/changeOfficialAccountActiveIndex',8)
          //     }
          //     that.$router.push('/pc/official/dialog').catch(err => { err })
          //   }
          // })
            if(getIsBasic() === 'true'){
                that.$store.dispatch('nav/changeOfficialAccountActiveIndex',5)
            }else{
                that.$store.dispatch('nav/changeOfficialAccountActiveIndex',8)
            }
            that.$router.push('/pc/official/dialog').catch(err => { err })
          return;
        }else{
          that.$store.dispatch('nav/changeOfficialAccountActiveIndex', 1)
          that.$store.dispatch('official/changeIsShowSlide', true)
          that.$router.push('/pc/official/invite').catch(err => { err })
          this.$store.dispatch('nav/changePersonalActiveIndex',0)
        }

      },
      toLogout(){
        this.$store.dispatch('nav/changePersonalActiveIndex',2)
        this.$store.dispatch('nav/changeIsGoOfficial', 0)
        this.$store.dispatch('user/logout')
        this.$Message.success('退出成功')
        this.$router.push('/')
      },
      // 跳转到我的推广位
      toPromotion(){
        this.$router.push('/pc/promotion/home').catch(err => { err })
        this.$store.dispatch('nav/changePersonalActiveIndex', 0)
      },
      //跳转到我的公众号
      toMyWechat(){
          this.$router.push('/pc/official/mywechat').catch(err => { err })
          this.$store.dispatch('official/changeIsShowSlide', true)
          this.$store.dispatch('nav/changePersonalActiveIndex', 1)
          this.$store.dispatch('nav/changeOfficialAccountActiveIndex', 1)
      },
      // 肯德基公众号
      toMyKfcWechat(){
        this.$router.push('/pc/kfc/mywechat').catch(err => { err })
        this.$store.dispatch('nav/changePersonalActiveIndex',3)
      },
      //跳转到首页
      toHome(){
        this.$router.push('/pc/official/home')
      },
      toAuthorization(){
        setPlatformUuid(0);
        setPlatformName('')
        setSnapshotId(-1) //表示新添加的公众号
        setIsOver(1)
        setIsBasic(true)
        setHasPackage(false)
        setIsAuthOfficial(false)
        setHeadImg('')
        this.$store.dispatch('official/changeIsShowSlide', true)
        if(getIsBasic() === 'true'){
          this.$store.dispatch('nav/changeOfficialAccountActiveIndex',5)
        }else{
          this.$store.dispatch('nav/changeOfficialAccountActiveIndex',8)
        }
        // this.$router.push({
        //   path: '/pc/official/dialog'
        // }).catch(err => { err })
        // window.open('#/pc/official/dialog?is_new=1','_self')
        // this.$router.go(0)
        this.$router.push({
          path: '/pc/official/dialog',
          query: { is_new: 1 }
        }).catch(err => { err })
      }
    }
  }
</script>

<style scoped>
  .main {
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  }
  .nav-wrap {
    height: 80px;
    background: #ffffff;
  }
  .nav-wrap .nav-box {
    width: 60%;
    margin: 0 auto;
    min-width: 850px;
  }
  .nav-wrap .nav-box .nav-div {
    width: 100%;
    height: 80px;
  }
  .nav-wrap .nav-box .nav-div .nav-left {
    float: left;
    width: 178px;
  }
  .nav-wrap .nav-box .nav-div .nav-left .logo {
    width: 178px;
    height: 80px;
    background: #ff8622;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
  }
  .nav-wrap .nav-box .nav-div .nav-left .logo img {
    height: 58px;
  }
  .nav-right {
    float: right;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .nav-right .official-account {
    float: right;
    height: 80px;
    font-size: 16px;
    color: #666666;
    padding-right: 20px;
    display: flex;
    flex-direction: column;
  }
  .nav-right .official-account .official-div{
    height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .nav-right .official-account .official-div .show-change{
    color: #3D9EFC;
    font-size: 12px;
    cursor: pointer;
  }
  .nav-right .official-account .avatar{
    width: 32px;
    height: 32px;
    border-radius: 16px;
  }
  .nav-right .official-account .account-name {
    font-size: 13px;
    color: #666666;
    max-width: 80px;
    margin: 0 5px;
    overflow: hidden;
    white-space:nowrap;
    word-break:break-all;
    text-overflow:clip;
    text-overflow:ellipsis;
  }
  .nav-right .auth-btn{
    font-family: Alibaba-PuHuiTi-R;
    background: #FF8622;
    border-radius: 2px;
    color: #FFFFFF;
    padding: 6px 15px;
    cursor: pointer;
    margin-right: 20px;
  }
  .nav-right .official-account .arrow-img{
    width: 20px;
  }
  .nav-right .official-account {
    float: right;
    height: 80px;
    font-size: 16px;
    color: #666666;
    padding-right: 20px;
  }
  .nav-right .official-account .official-div{
    height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .nav-right .official-account .avatar{
    width: 32px;
    height: 32px;
    border-radius: 16px;
  }
  .nav-right .official-account .account-name {
    font-size: 13px;
    color: #666666;
    max-width: 80px;
    margin: 0 5px;
    overflow: hidden;
    white-space:nowrap;
    word-break:break-all;
    text-overflow:clip;
    text-overflow:ellipsis;
  }
  .nav-right .official-account .arrow-img{
    width: 20px;
  }
  .nav-right .user {
    float: right;
    height: 80px;
    font-size: 16px;
    color: #666666;
    display: flex;
    flex-direction: column;
  }
  .nav-right .user .user-div{
    height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .nav-right .user .avatar{
    width: 32px;
    height: 32px;
    border-radius: 16px;
  }
  .nav-right .user .nickname {
    font-size: 13px;
    color: #666666;
    max-width: 80px;
    margin: 0 5px;
    overflow: hidden;
    white-space:nowrap;
    word-break:break-all;
    text-overflow:clip;
    text-overflow:ellipsis;
  }
  .nav-right .user .arrow-img{
    width: 20px;
    cursor: pointer;
    position: relative;
  }
  .nav-right .user .arrow-img img{
    width: 100%;
  }
  .nav-right .nav-dialog-box {
    background: #FFFFFF;
    width: 100px;
    position: absolute;
    bottom: -10px;
    left: -40px;
    border-top: 1px solid #EEEEEE;
  }
  .nav-right .nav-dialog-box span {
    width:0;
    height:0;
    font-size:0;
    overflow:hidden;
    position:absolute;
  }
  .nav-right .nav-dialog-box .bot{
    border-width: 8px;
    border-style: solid dashed dashed;
    border-color: transparent transparent #EEEEEE transparent;
    left: 44%;
    top: -16px;
  }
  .nav-right .nav-dialog-box .top{
    border-width:8px;
    border-style:solid dashed dashed;
    border-color: transparent transparent #FFFFFF transparent;
    left:44%;
    top:-15px;
  }
  .nav-right .nav-dialog-box .nav-item{
    position: absolute;
    width: 100%;
    text-align: center;
    font-size: 13px;
    color: #666666;
    line-height: 36px;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    border-top: none;
    z-index: 999;
    cursor: pointer;
  }
  .nav-right .nav-dialog-box .nav-item div{
    height: 36px;
  }
  .nav-right .nav-dialog-box .nav-item .active{
    background: #FCFAF8;
    color: #D63036;
  }
  .nav-right .official-dialog-box {
    background: #FFFFFF;
    width: 160px;
    position: relative;
    top: 8px;
    border-top: 1px solid #EEEEEE;
  }
  .nav-right .official-dialog-box span {
    width:0;
    height:0;
    font-size:0;
    overflow:hidden;
    position:absolute;
  }
  .nav-right .official-dialog-box .bot{
    border-width: 8px;
    border-style: solid dashed dashed;
    border-color: transparent transparent #EEEEEE transparent;
    left: 44%;
    top: -16px;
  }
  .nav-right .official-dialog-box .top{
    border-width:8px;
    border-style:solid dashed dashed;
    border-color: transparent transparent #FFFFFF transparent;
    left:44%;
    top:-15px;
  }
  .nav-right .official-dialog-box .official-item{
    position: absolute;
    width: 100%;
    text-align: center;
    font-size: 13px;
    color: #666666;
    line-height: 36px;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    border-top: none;
    z-index: 999;
  }
  .nav-right .official-dialog-box .official-item .official-item-div{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
  .nav-right .official-dialog-box .official-item .official-item-div .item-change{
    color: #3D9EFC;
    cursor: pointer;
  }
  .nav-right .official-dialog-box .official-item img{
    height: 30px;
    margin-top: 3px;
  }
  .nav-right .official-dialog-box .official-item .active{
    background: #FCFAF8;
    color: #FF9734;
  }
  @media (min-width: 768px) {
    .nav-wrap .nav-box {
      width: 85%;
    }
  }
  @media (min-width: 992px) {
    .nav-wrap .nav-box {
      width: 80%;
    }
  }
  @media (min-width: 1200px) {
    .nav-wrap .nav-box {
      width: 70%;
    }
  }
  @media (min-width: 1400px) {
    .nav-wrap .nav-box {
      width: 62.5%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/OfficialNav.vue